import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { InputPreviewText } from '../PreviewText'
import InputAutoComplete from './AutoComplete.vue'

const TransformAutoComplete = transformComponent(InputAutoComplete, {
  change: 'input',
})

const AutoComplete = connect(
  TransformAutoComplete,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText),
)

export default AutoComplete
